// Deprecated 
import _map from 'lodash/map'
import _isUndefined from 'lodash/isUndefined'
import _parseInt from 'lodash/parseInt'
import _uniqBy from 'lodash/uniqBy'
import _filter from 'lodash/filter'
import _findIndex from 'lodash/findIndex'
import _remove from 'lodash/remove'
import oboe from 'oboe'
import moment from 'moment'
import React from 'react'
import PropTypes from 'prop-types'
import { makeURL } from '../../_common/core/http'
import { HTTP_INIT, HTTP_LOADING, HTTP_LOADING_SUCCESSED, HTTP_LOADING_FAILED, CACHE_SIZE } from '../../_common/core/http'

import { Pagination } from './Pagination'
import SearchBox from './SearchBox'
import Select from './Select'
import LoadingBar from './LoadingBar'
import Button from './Button'
import OverlayTrigger from 'react-bootstrap/lib/OverlayTrigger'
import Tooltip from 'react-bootstrap/lib/Tooltip'
import ClipboardButton from 'react-clipboard.js'

// const select_panel_size = _map([5, 10], (e, i) => {
// 	return {value: e, label: e}
// })
const select_page_size = _map([10, 50, 100, 250, 500, 1000], (e, i) => ({ value: e, label: e }))
const convertToCSV = (args) => {
  let result; let ctr; let keys; let columnDelimiter; let lineDelimiter; let data

  data = args.data || null
  if (data == null || !data.length) {
    return null
  }

  columnDelimiter = args.columnDelimiter || ','
  lineDelimiter = args.lineDelimiter || '\n'

  keys = Object.keys(data[0])

  result = ''
  // result += keys.join(columnDelimiter)
  // result += lineDelimiter

  data.forEach((item) => {
    ctr = 0
    keys.forEach((key) => {
      if (ctr > 0) result += columnDelimiter

      result += item[key]
      ctr++
    })
    result += lineDelimiter
  })

  return result
}

export const IS_FOUND = (value, keyword) => {
  if(!value)
    return 0
  return value.toLowerCase().indexOf(keyword) != -1 ? 1 : 0
}

export const DOWNLOAD_CSV = (csvData, csvFileName) => {
  let data; let filename; let link
  const csv = convertToCSV({
    data: csvData
  })
  if (csv == null) return

  filename = csvFileName

  // if (!csv.match(/^data:text\/csv/i)) {
  // 	csv = 'data:text/csv;charset=utf-8,' + csv
  // }
  // data = encodeURI(csv)
  const blob = new Blob([csv], { type: 'text/csv' })
  const csvUrl = URL.createObjectURL(blob)

  link = document.createElement('a')
  link.setAttribute('href', csvUrl)
  link.setAttribute('download', filename)
  link.click()
}

export const SEARCHBAR = 'dt_searchbar'
export const DATATABLE = 'dt_table'
export const PAGINATIONBAR = 'dt_paginationbar'
export const RESALE_STATUS = 'dt_resale_status'

export const TYPE_FROM_URL  = 'url'
export const TYPE_FROM_ARRAY= 'array'

export class JSONDatatable extends React.Component{
	static propType = {
	  // required
	  type: PropTypes.string.isRequired, // TYPE_FROM_URL('url') or TYPE_FROM_ARRAY('array')
	  parent_http_status: PropTypes.number, // only used if type is array
	  data: PropTypes.object.isRequired, // {url, node} or []

	  validateData: PropTypes.func,
	  getFilteredRows: PropTypes.func,
	  getSortedRows: PropTypes.func.isRequired,
	  getTableData: PropTypes.func.isRequired,
	  labelTotalCount: PropTypes.string.isRequired,

	  // not mandatory 	// ''
	  stopOnInvisible: PropTypes.bool, // true: stop functioning when invisible
	  fetchCallback: PropTypes.func,
	  loadingBarTitle: PropTypes.string.isRequired,
	  getCSVData: PropTypes.func,
	  usePagination: PropTypes.bool,
	  onlyOboe: PropTypes.bool, // true: don't apply table wrapper class, false: apply normal table class
	  countInDownloading: PropTypes.number, // use this in downloading
	  cacheSize: PropTypes.number, // if set, CACHE_SIZE will be override.
	  paginationPanelSize: PropTypes.number,
	  paginationPageSize: PropTypes.number,
	  sort: PropTypes.object, // default sort
	  autoRefresh: PropTypes.number, // time interval for autoRefresh periodically
	  keepExpanded: PropTypes.string,
	  saveSearchKey: PropTypes.string, // null or empty string will disable saveSearch
	  fullReady: PropTypes.bool,
	}

	constructor(props) {
	  super(props)

	  this.tmp = []
	  this.refreshFlag = false
	  this.refreshTimer = null
	  this.refreshEndTime = null
	  this.backupRows = []
	  this.unMounted = true
	  this.expandedRowID = null
	  this.everLoaded = false

	  let savedSearch = null
	  if(props.saveSearchKey && props.saveSearchKey.length > 0) {
	    savedSearch = localStorage.getItem(props.saveSearchKey)
	  }

	  let http_status = HTTP_INIT
	  if (props.type === TYPE_FROM_ARRAY) {
	    http_status = _isUndefined(props.parent_http_status) ? HTTP_LOADING_SUCCESSED : props.parent_http_status
	  }

	  this.state = {
	    http_status,
	    http_error: null,

	    rows: [],
	    rows_filtered: [],
	    rows_displayed: [],
	    csvData: [],
	    sort: this.props.sort,
	    search: savedSearch && savedSearch.length > 0 ? [savedSearch] : [],
	    searchDone: savedSearch && savedSearch.length > 0,

	    totalCount: 0,
	    pn_activePage: 1,
	    pn_panelSize: props.paginationPanelSize ? props.paginationPanelSize : 10,
	    pn_pageSize: props.paginationPageSize ? props.paginationPageSize : 50,

	    clipboardCopied: false,
	    tags: [],
	    resaleStatusOptions: []
	  }

	  this.onPageSizeChanged = this.onPageSizeChanged.bind(this)
	  this.onPageNumberChange = this.onPageNumberChange.bind(this)
	  this.handleScroll = this.handleScroll.bind(this)
	  this.onSearchChange = this.onSearchChange.bind(this)
	}

	componentDidMount() {
	  if(this.props.onRef)
	    this.props.onRef(this)
	  if(this.props.stopOnInvisible)
	    window.addEventListener('scroll', this.handleScroll)
	  this.unMounted = false
	  const { type, data, autoRefresh } = this.props
	  this.init(this.props)
	  const self = this
	  if(autoRefresh && autoRefresh > 1000){
	    self.refreshTimer = setInterval(()=>{
	      if((self.state.http_status == HTTP_LOADING_SUCCESSED || self.state.http_status == HTTP_LOADING_FAILED) && !self.refreshFlag){
	        self.refreshFlag = true
	        self.init(this.props)
	      }else{
	        // console.log('autoRefresh is already in progress')
	      }
	    }, autoRefresh)
	  }
	}

	componentWillUnmount() {
	  if(this.props.onRef)
	    this.props.onRef(undefined)
	  if(this.props.stopOnInvisible)
	    window.removeEventListener('scroll', this.handleScroll)
	  this.refreshFlag = false
	  this.expandedRowID = null
	  this.unMounted = true
	  if(this.refreshTimer)
	    clearInterval(this.refreshTimer)
	}

	componentWillReceiveProps(nextProps) {
	  const { type, isInvisible, paginationPageSize } = this.props
	  if (paginationPageSize !== nextProps.paginationPageSize) {
	    this.state.pn_pageSize = nextProps.paginationPageSize || 50
	  }
	  if((type == TYPE_FROM_URL && JSON.stringify(this.props.data)!=JSON.stringify(nextProps.data)) ||  (!this.props.autoUpdate && nextProps.autoUpdate)
		|| (type == TYPE_FROM_ARRAY && (isInvisible != nextProps.isInvisible || (this.props.data !== nextProps.data)))){
	    // console.log('JSONDatatable props changed, refresh called')
	    this.forceRefresh(nextProps, nextProps.parent_http_status)
	  } else {
	    setTimeout(() => {
	      this.refreshState(this.state.rows, this.state.http_status, null, this.state.sort, this.state.search, this.state.pn_activePage, this.state.pn_panelSize, this.state.pn_pageSize, this.state.tags)
	    }, 0)
	  }
	}

	handleScroll(){
	  if(this.unMounted)
	    return
	  const isVisible = this.isInVisibleArea()
	  if(isVisible && !this.everLoaded){
	    const { type, data, autoRefresh } = this.props
	    this.init(this.props)
	  }
	}

	isInVisibleArea(){
	  const ele = $(this.refs.JSONDatatable)
	  if(!ele)
	    return false
	  const windowTop = $(window).scrollTop()
	  const windowBottom = $(window).scrollTop() + $(window).height()
	  const elementTop = ele.offset().top
	  const elementBottom = ele.offset().top+ele.height()
	  return elementTop >= windowTop ? elementTop <= windowBottom : elementBottom >= windowTop
	}

	// export function
	forceRefresh(props, parent_http_status){
	  this.refreshFlag = true
	  this.init(props, parent_http_status)
	}

	manualRefresh() {
	  this.refreshFlag = true
	  this.init(this.props)
	}

	init(props, parent_http_status){
	  const { type, data, keepExpanded, isInvisible, onDataChange } = props
	  const self = this

	  if (onDataChange) {
	    onDataChange(data)
	  }

	  if(this.props.stopOnInvisible){
	    const isVisible = this.isInVisibleArea()
	    if(!isVisible){
	      this.refreshFlag = false
	      return
	    }
	    this.everLoaded = true
	  }

	  if(!!isInvisible){
	    this.refreshFlag = false
	    return
	  }

	  this.tmp = []

	  switch(type){
	  case TYPE_FROM_URL:
	    const { url, param, node, path } = data

	    oboe({
	      url: makeURL(url, param),
	      method: 'GET',
	      headers: {
	        'Accept': 'application/vnd.api+json',
	        'Content-Type': 'application/vnd.api+json'
	      },
	      withCredentials: true
	    }).node(node, (record, pathArray) => {
	      if(!!path){
	        record._key = pathArray[path]
	      }
	      if(!self.unMounted){
	        self.tmp.push(record)
	        const cacheSize = this.props.cacheSize || CACHE_SIZE
	        if(self.tmp.length === cacheSize && !self.refreshFlag){
	          self.addToRow(self.tmp, HTTP_LOADING, null)
	        }
	      }
	    }).done(() => {
	      if(!self.unMounted)
	        self.addToRow(null, HTTP_LOADING_SUCCESSED, null)
	    }).fail((errorReport) => {
	      if(!self.unMounted)
	        self.addToRow(null, HTTP_LOADING_FAILED, errorReport)
	    })
	    break
	  case TYPE_FROM_ARRAY:
	    let rows = []
	    _map(data, (o, index)=>{
	      const newRow = this.props.validateData ? this.props.validateData(Object.assign({}, o), index) : Object.assign({}, o)
	      if(newRow){
	        if(!newRow.id)
	          newRow.id = index
	        newRow.isExpanded = newRow.id == keepExpanded
	        newRow.isDetailRow = false
	        if(Array.isArray(o)) {
	          newRow.length = o.length
	        }
	        rows.push(newRow)
	        if(newRow.isExpanded){
	          const detail = Object.assign({}, newRow)
	          detail.id += '_detail'
	          detail.isDetailRow = true
	          rows.push(detail)
	        }
	      }
	    })
	    let status = HTTP_LOADING_SUCCESSED
	    if(parent_http_status)
	      status = parent_http_status
	    if(status == HTTP_LOADING_SUCCESSED){
	      this.refreshEndTime = Date.now()
	      this.backupRows = rows.slice(0)
	    }else{
	      rows = this.backupRows
	    }
	    this.refreshState(rows, status, null, this.state.sort, this.state.search, this.state.pn_activePage, this.state.pn_panelSize, this.state.pn_pageSize, this.state.tags)
	    break
	  default:
	    break
	  }
	}

	addToRow(cached, http_status, http_error){
	  let rows = this.refreshFlag ? [] : this.state.rows

	  const tmp = !!cached ? cached : this.tmp
	  const start = rows.length
	  _map(tmp, (o, index)=>{
	    // newRow.id = index
	    const newRow = this.props.validateData ? this.props.validateData(Object.assign({}, o), start + index) : Object.assign({}, o)
	    if(newRow){
	      if(!newRow.id)
	        newRow.id = index
	      newRow.isExpanded = this.refreshFlag && newRow.id == this.expandedRowID
	      newRow.isDetailRow = false
	      rows.push(newRow)
	      if(newRow.isExpanded){
	        const detail = Object.assign({}, newRow)
	        detail.id += '_detail'
	        detail.isDetailRow = true
	        rows.push(detail)
	      }
	    }
	  })
	  if(http_status == HTTP_LOADING_SUCCESSED || http_status == HTTP_LOADING_FAILED){
	    if(http_status == HTTP_LOADING_SUCCESSED){
	      this.refreshEndTime = Date.now()
	      this.backupRows = rows.slice(0)
	    }else{
	      rows = this.backupRows
	    }
	    if(this.props.fetchCallback)
	      this.props.fetchCallback(rows, http_status, http_error)
	  }
	  if(this.refreshFlag){
	    this.refreshFlag = false
	  }
	  this.tmp = []
	  this.refreshState(rows, http_status, http_error, this.state.sort, this.state.search, this.state.pn_activePage, this.state.pn_panelSize, this.state.pn_pageSize, this.state.tags)
	}

	onSort(index){
	  let { sort } = this.state
	  if(sort && index == sort.index){
	    sort.asc = !sort.asc
	  }else{
	    sort = { index, asc: false }
	  }
	  this.refreshState(this.state.rows, this.state.http_status, this.state.http_error, sort, this.state.search, this.state.pn_activePage, this.state.pn_panelSize, this.state.pn_pageSize, this.state.tags)
	}

	onClickDetail = (id) => {
	  const newRows = this.processDetail(this.state.rows, id)
	  this.refreshState(newRows, this.state.http_status, this.state.http_error, this.state.sort, this.state.search, this.state.pn_activePage, this.state.pn_panelSize, this.state.pn_pageSize, this.state.tags)
	}

	onSearchChange(value, focusAfter, triggerScroll){
	  const searchDone = value.join('').trim().length === 0 ? false : true
	  if(focusAfter){
	    $(focusAfter).parent().scrollLeft(0)
	    setTimeout(()=>{
	      const offset = $(focusAfter).offset() // Contains .top and .left
	      const pOffset = $(focusAfter).parent().offset()
	      $(focusAfter).parent().animate({
	        scrollLeft: offset.left - pOffset.left
	      })
	    }, 200)
	  }
	  if(triggerScroll){
	    setTimeout(()=>{
	      $('html, body').animate({
	        scrollTop: $(window).scrollTop() + 1
	      })
	    }, 100)
	  }
	  if(this.props.saveSearchKey && this.props.saveSearchKey.length > 0) {
	    localStorage.setItem(this.props.saveSearchKey, value.join('').trim())
	  }
	  this.setState(() => ({ searchDone }))
	  this.refreshState(this.state.rows, this.state.http_status, this.state.http_error, this.state.sort, value, this.state.pn_activePage, this.state.pn_panelSize, this.state.pn_pageSize, this.state.tags)
	}

	onPageNumberChange(pageNumber) {
	  const newRows = this.processDetail(this.state.rows, null) // remove detail row
	  this.refreshState(newRows, this.state.http_status, this.state.http_error, this.state.sort, this.state.search, pageNumber, this.state.pn_panelSize, this.state.pn_pageSize, this.state.tags)
	}

	onPanelSizeChanged(e){
	  this.refreshState(this.state.rows, this.state.http_status, this.state.http_error, this.state.sort, this.state.search, this.state.pn_activePage, _parseInt(e.target.value), this.state.pn_pageSize, this.state.tags)
	}

	onPageSizeChanged(e){
	  this.refreshState(this.state.rows, this.state.http_status, this.state.http_error, this.state.sort, this.state.search, this.state.pn_activePage, this.state.pn_panelSize, _parseInt(e.target.value), this.state.tags)
	}

	processDetail(rows, id){ // id for the row with details
	  const newRows = []
	  this.expandedRowID = null
	  for(let i = 0; i< rows.length; i++){
	    const row = rows[i]
	    if(row.id == id && !row.isDetailRow){
	      const { isExpanded } = row
	      row.isExpanded = !isExpanded
	      newRows.push(Object.assign({}, row))
	      if(row.isExpanded){
	        this.expandedRowID = row.id
	        const detail = Object.assign({}, row)
	        detail.id += '_detail'
	        detail.isDetailRow = true
	        newRows.push(detail)
	      }
	    }else{
	      if(!row.isDetailRow){
	        const newRow = Object.assign({}, row)
	        newRow.isExpanded = false
	        newRows.push(newRow)
	      }
	    }
	  }
	  return newRows
	}

	refreshState(rows, http_status, http_error, sort, search, pageNumber, panelSize, pageSize, tags){
	  let rows_filtered = null; let rows_filtered_detailRemoved = null; let rows_displayed = null
	  let csvData = null
	  let resaleStatusOptions = rows ? _map(rows, r => ({ label: r.status, value: r.status })) : []
	  resaleStatusOptions = _uniqBy(resaleStatusOptions, 'value')
	  if(http_status == HTTP_LOADING){
	    rows_filtered = rows
	    rows_filtered_detailRemoved = rows
	  }else{
	    rows_filtered = this.props.getFilteredRows ? this.props.getFilteredRows(rows, search) : rows
	    if(this.props.getSortedRows){
	      rows_filtered = this.props.getSortedRows(rows_filtered, sort)
	    }
	    rows_filtered_detailRemoved = _filter(rows_filtered, { 'isDetailRow': false })
	    if (tags && tags.length) {
	      rows_filtered_detailRemoved = _filter(rows_filtered_detailRemoved, r => _findIndex(tags, t => r.status === t) !== -1)
	    }
	    if(this.props.getCSVData){
	      csvData = this.props.getCSVData(rows_filtered_detailRemoved)
	    }
	  }

	  const totalCount = rows_filtered_detailRemoved.length // remove detail rows
	  if(this.props.usePagination){
	    if((pageNumber - 1) * pageSize >= totalCount){
	      pageNumber = 1
	    }

	    const startPos = (pageNumber - 1) * pageSize; const endPos = pageNumber * pageSize
	    rows_displayed = rows_filtered_detailRemoved.slice(startPos, endPos)
	    let hasDetailRow = false
	    _map(rows_displayed, (row, index) => {
	      if(row.isExpanded)
	        hasDetailRow = true
	    })
	    if(hasDetailRow){
	      rows_displayed = rows_filtered.slice(startPos, endPos + 1)
	    }
	  }else{
	    if(http_status == HTTP_LOADING){
	      const count = this.props.countInDownloading ? this.props.countInDownloading + 1 : pageSize
	      rows_displayed = rows_filtered_detailRemoved.slice(0, count)
	    }else
	      rows_displayed = rows_filtered
	  }

	  if(this.props.setTotalCount)
	    this.props.setTotalCount(totalCount)

	  this.setState(() =>({
	    http_status,
	    http_error,

	    rows,
	    rows_filtered,
	    rows_displayed,
	    csvData,
	    sort,
	    search,
	    tags,

	    totalCount,
	    pn_activePage: pageNumber,
	    pn_panelSize: panelSize,
	    pn_pageSize: pageSize,
	    resaleStatusOptions,
	  }))
	}

	// drawing helper functions
	getHeaderRow(self, headers, sort){
	  const tharray = _map(headers, (h, index)=>h.sort ? (
	    <th key={index} style={{ cursor: 'pointer' }} onClick={self.onSort.bind(self, index)} className={h.className}>
	      {h.title}
	      {sort && sort.index == index &&
						<i className={'sort-direction ' + (sort.asc ? 'fa fa-caret-up' : 'fa fa-caret-down')} aria-hidden='true'/>
	      }
	    </th>
	  ): (
	    <th key={index} className={h.className}>
	      {h.title}
	    </th>
	  ))
	  return (
	    <tr>
	      {tharray}
	    </tr>
	  )
	}

	getClipboardColumn(self, content) {
	  const clipboard_html = (
	    <div className="clipboard" onMouseLeave={self.clipboardOut.bind(self)}>
	      <ClipboardButton component="span" data-clipboard-text={content} onSuccess={self.copyClipboardAfter.bind(self)}>
	        <OverlayTrigger
	          placement="left"
	          overlay={
	            this.state.clipboardCopied ?
	              <Tooltip id="clipboardCopied">Copied</Tooltip>:
	              <Tooltip id="clipboardCopied">Copy</Tooltip>
	          }
	          trigger={['hover']}
	        >
	          <i className="fa fa-clipboard" />
	        </OverlayTrigger>
	      </ClipboardButton>
	    </div>
	  )
	  return clipboard_html
	}

	onClickExportCSV(csvData, csvFileName){
	  DOWNLOAD_CSV(csvData, csvFileName)
	}

	copyClipboardAfter() {
	  this.setState(() => ({
	    clipboardCopied: true
	  }))
	}

	clipboardOut(e) {
	  if(this.state.clipboardCopied) {
	    setTimeout(() => {
	      this.setState(() => ({
	        clipboardCopied: false
	      }))
	    }, 500)
	  }
	}

	toggleTag = (tag) => {
	  const { tags } = this.state
	  const _tags = tags || []
	  if(_tags.includes(tag)) {
	    _remove(_tags, (t) => (t==tag))
	  } else {
	    _tags.push(tag)
	  }
	  this.refreshState(this.state.rows, this.state.http_status, this.state.http_error, this.state.sort, this.state.search, this.state.pn_activePage, this.state.pn_panelSize, this.state.pn_pageSize, _tags)
	}

	clearTags = () => {
	  this.refreshState(this.state.rows, this.state.http_status, this.state.http_error, this.state.sort, this.state.search, this.state.pn_activePage, this.state.pn_panelSize, this.state.pn_pageSize, [])
	}

	render() {
	  const { http_status, http_error, rows_filtered, rows_displayed, sort, search, totalCount, searchDone, tags, resaleStatusOptions } = this.state
	  const { type, data } = this.props
	  // console.log('total: ' + totalCount + ', url: ' + (type == TYPE_FROM_URL ? data.url + data.node : ''))

	  const self = this

	  const { children } = this.props
	  const childs = []; let lastUpdated = null
	  if(http_status == HTTP_INIT){
	    childs.push(<LoadingBar key='loadingbar' title={this.props.loadingBarTitle} />)
	  }else if(http_status == HTTP_LOADING){
	    childs.push(<LoadingBar key='download' className='downloading' title={'Downloaded: ' + totalCount} />)
	  }else if(http_status == HTTP_LOADING_FAILED){
	    if(!this.refreshEndTime){
	      console.log('http_error', http_error)
	      childs.push(<LoadingBar key='error' title={'Error Occurred!'} />)
	    }else{
	      lastUpdated = (
	        <div key='offline_message' className="card text-center">
	          <div className="card-block text-center text-muted">
	            <div className="offline_message">
	              <img src='data:image/png;base64,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'/>
	              <div className="bold">You are working offline. </div>
	              <div>Information last updated on {moment(this.refreshEndTime).format('D MMM YYYY')} at {moment(this.refreshEndTime).format('hh:mm:ss')}</div>
	            </div>
	          </div>
	        </div>
	      )
	    }
	  }

	  if(http_status != HTTP_LOADING_FAILED || (http_status == HTTP_LOADING_FAILED && this.refreshEndTime != null)){
	    // make child array evenif there is only one child.
	    let childArray = []
	    if(!Array.isArray(children)){
	      childArray.push(children)
	    }else{
	      childArray = children
	    }

	    // render
	    _map(childArray, (c, index)=>{
	      if(c == null){
	      } else if (c.ref == SEARCHBAR) {
	        if(http_status > HTTP_LOADING) {
	          const { hasSearch, alwaysShowTotalCount, alwaysShowSearch, autoFocus, hasLeftSection, children, focusAfter, triggerScroll } = c.props
	          let searchBar = null

	          if(hasLeftSection){ // only used in `orders` section
	            searchBar = <div key={index} className={'datatable-searchbar ' + c.props.className}>
	              <div className="searchbar-left">
	                {children}
	              </div>
	              <div className="searchbar-right">
	                {hasSearch && (totalCount != 0 || searchDone) &&
										<SearchBox autoFocus={autoFocus} triggerScroll={triggerScroll} value={search} onChange={this.onSearchChange} focusAfter={focusAfter}/>
	                }
	                {!this.props.hideTotalCount && (searchDone || alwaysShowTotalCount) && <div className="search-result">{c.props.labelTotalCount}: <span className="total-count">{totalCount}</span></div>}
	              </div>
	            </div>
	          }else{
	            searchBar = <div key={index} className={'datatable-searchbar ' + c.props.className}>
	              <div className="searchbar-left search-result">
	                {!this.props.hideTotalCount && (searchDone || alwaysShowTotalCount) && <div className="search-results-counter">{c.props.labelTotalCount}: {totalCount}</div>}
	              </div>
	              <div className="searchbar-right">
	                {hasSearch && (alwaysShowSearch || totalCount != 0 || searchDone) &&
										<SearchBox autoFocus={autoFocus} triggerScroll={triggerScroll} value={search} onChange={this.onSearchChange} focusAfter={focusAfter}/>
	                }
	              </div>
	            </div>
	          }
	          childs.push(searchBar)
	        }
	      } else if (c.ref === RESALE_STATUS) {
	        if (http_status > HTTP_LOADING && resaleStatusOptions && resaleStatusOptions.length) {
	          childs.push(
	            <div key={index} className="performance-by-ticket">
	              <div className="filters">
	                <div className="tag-filter-label"><i className="fa fa-tags"/>{'Filter by Resale Status'}</div>
	                {resaleStatusOptions.map((t, i) =>
	                  <div key={i} className={'tag-filter'+(tags.includes(t.value) ? ' selected' : '')} onClick={()=>{this.toggleTag(t.value)}}>{t.label}</div>
	                )}
	                {tags.length> 0 && <Button className="btn btn-default btn-shadow tags-clear" type="button" onClick={this.clearTags}>Clear Filter</Button>}
	              </div>
	            </div>
	          )
	        }

	      } else if (c.ref == DATATABLE) {
	        if(http_status >= HTTP_LOADING) {
	          const content_table = this.props.getTableData(this, rows_displayed, sort, totalCount)
	          const className = this.props.onlyOboe ? '' : 'datatable-tablecontent table-responsive ' + c.props.className
	          const div = <div key={index} className={className}>
	            {content_table}
	          </div>
	          childs.push(div)
	        }
	      } else if (c.ref == PAGINATIONBAR) {
	        if(http_status > HTTP_LOADING) {
	          const { hasCSVExport, csvFileName } = c.props
	          const { csvData, pn_activePage, pn_pageSize, pn_panelSize } = this.state
	          const paginationBar = <div key={index} className={'row datatable-paginationbar ' + c.props.className}>
	            <div className="col-xs-12 panigation-panel">
	              <div className="pagination-select-panelsize">
	                {hasCSVExport && csvData &&
										<Button className="btn btn-primary" disabled={!totalCount} onClick={this.onClickExportCSV.bind(this, csvData, csvFileName)}>Export To CSV</Button>
	                }
	                {/*<Select
										label="PanelSize"
										value={pn_panelSize}
										options={select_panel_size}
										onChange={::this.onPanelSizeChanged}
									onBlur={::this.onPanelSizeChanged} />*/}
	              </div>
	              <div className="text-center">
	                { totalCount > pn_pageSize &&
									<Pagination
									  activePage={pn_activePage}
									  pageRangeDisplayed={pn_panelSize}
									  itemsCountPerPage={pn_pageSize}
									  totalItemsCount={totalCount}
									  onChange={this.onPageNumberChange}
									/>
	                }
	              </div>
	              <div className="pagination-select-pgsize">
	                { totalCount > pn_pageSize &&
									<Select
									  label="Page Size"
									  value={pn_pageSize}
									  options={select_page_size}
									  onChange={this.onPageSizeChanged}
									  onBlur={this.onPageSizeChanged} />
	                }
	              </div>
	            </div>
	          </div>
	          childs.push(paginationBar)
	        }
	      } else {
	        // c.key = index
	        if(http_status > HTTP_LOADING){
	          if(c.props.getContent){
	            childs.push(c.props.getContent(rows_filtered))
	          }else{
	            childs.push(c)
	          }
	        }
	        if(http_status == HTTP_LOADING){
	          if(c.props.getContent && c.props.showOnLoading)
	            childs.push(c.props.getContent(rows_filtered))
	        }
	      }
	    })

	    if(lastUpdated != null) {
	      childs.push(lastUpdated)
	    }
	  }

	  return (
	    <div ref="JSONDatatable" className="JSONDatatable">
	      {childs}
	    </div>
	  )
	}
}
